// extracted by mini-css-extract-plugin
export default {"milestone":"index_milestone_75BxP"};